"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParseError_1 = require("../../errors/ParseError");

var AbstractNode =
/*#__PURE__*/
function () {
  _createClass(AbstractNode, [{
    key: "hasBody",
    get: function get() {
      return false;
    }
  }]);

  function AbstractNode(type, token) {
    _classCallCheck(this, AbstractNode);

    this.type = type;
    this.start = token.start;
    this.end = token.end;
  }

  _createClass(AbstractNode, [{
    key: "addToNode",
    value: function addToNode(child) {
      throw new ParseError_1.default("Node ".concat(this.type, " can't contain ").concat(child.type), child);
    }
  }]);

  return AbstractNode;
}();

exports.default = AbstractNode;